import { render } from "./ClickQuicklinkIcon.vue?vue&type=template&id=fe5c3cf6"
import script from "./ClickQuicklinkIcon.vue?vue&type=script&lang=js"
export * from "./ClickQuicklinkIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__